module.exports = __webpack_public_path__ + "img/created-by-jobmule.72b89c95.png";